export default {
    職種コード: '職種コード',
    職種名称: '職種名',
    フリガナ: 'フリガナ',
    職種略称: '略称',
    管理監督者: '労働基準法上の管理監督者とする'
};
